import {geocodeByAddress, getLatLng} from "react-places-autocomplete";
import {countryList} from "../constants/countryList";

export const isCountry = (element) => element.types.includes("country");
export const isAdminLevel1 = (element) =>
  element.types.includes("administrative_area_level_1");
export const isAdminLevel2 = (element) =>
  element.types.includes("administrative_area_level_2");
export const isAdminLevel3 = (element) =>
  element.types.includes("administrative_area_level_3");
export const isLocality = (element) => element.types.includes("locality");
export const isPostalCode = (element) => element.types.includes("postal_code");
export const isPostalCodeSuffix = (element) =>
  element.types.includes("postal_code_suffix");

export const createPrecise = (a) => {
  if (Math.abs(a) < 1) return a.toPrecision(6);
  if (Math.abs(a) < 10) return a.toPrecision(7);
  return a.toPrecision(8);
};

/**
 * Geocodes an address string and parses the result into structured address fields.
 * Returns null if the selected place has no country component.
 */
export const parseGoogleAddress = async (address) => {
  const results = await geocodeByAddress(address);
  const geometryValue = await getLatLng(results[0]);
  const lat = createPrecise(geometryValue.lat);
  const lng = createPrecise(geometryValue.lng);
  const addressDetails = results[0].address_components;

  const selectedCountry = addressDetails.find(isCountry);
  if (!selectedCountry) return null;

  const countryName = selectedCountry?.long_name || "";
  const country =
    countryName && countryList.find((each) => each.value === countryName)
      ? countryName
      : "";

  const postalCode = addressDetails.find(isPostalCode)?.long_name || "";
  const state = addressDetails.find(isAdminLevel1)?.long_name || "";
  const locality = addressDetails.find(isLocality)?.long_name;
  const adminLevel3 = addressDetails.find(isAdminLevel3)?.long_name;
  const city = locality || adminLevel3 || "";

  const streetAddress = addressDetails
    .filter(
      (element = {}) =>
        element.long_name &&
        !isCountry(element) &&
        !isAdminLevel1(element) &&
        !isAdminLevel2(element) &&
        !isAdminLevel3(element) &&
        !isLocality(element) &&
        !isPostalCode(element) &&
        !isPostalCodeSuffix(element)
    )
    .map((element) => element.long_name)
    .join(" ");

  return {
    country,
    state,
    city,
    postalCode,
    streetAddress,
    latitude: lat || 0.0,
    longitude: lng || 0.0,
  };
};
